module.exports = __webpack_public_path__ + "static/media/JBL_Partybox.de86e4c6.glb";